export default __webpack_public_path__ + "static/media/slider8.f40f13a4.jpg";